import { FunctionComponent } from 'react';
import { Autoplay, EffectCoverflow } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { generateEmptyItemsArray } from '../../../utils/generateEmptyItems';

import { CarouselContentProps } from '../../CarouselContent';
import { CarouselItem } from '../CarouselItem';
import { EmptySlide } from '../EmptySlide';

const Carousel7: FunctionComponent<CarouselContentProps> = ({
  itemsCarousel,
  autoplayCarousel,
  loopCarousel,
  speedCarousel,
  objectFit,
}) => {
  const minItems = 3;
  const emptyItems = generateEmptyItemsArray(minItems, itemsCarousel.length);
  return (
    <Swiper
      allowTouchMove={false}
      autoplay={{ disableOnInteraction: false }}
      centeredSlides={true}
      coverflowEffect={{
        depth: 100,
        modifier: 1,
        rotate: 50,
        slideShadows: true,
        stretch: 0,
      }}
      css={{
        width: '100%',
        height: '100%',
      }}
      effect={'coverflow'}
      grabCursor={true}
      loop={loopCarousel}
      modules={[EffectCoverflow, autoplayCarousel ? Autoplay : undefined]}
      noSwiping={true}
      noSwipingClass="swiper-slide"
      slidesPerView={3}
      speed={speedCarousel}
    >
      {itemsCarousel.map((item) => (
        <SwiperSlide key={item.id}>
          <CarouselItem item={item} objectFit={objectFit} />
        </SwiperSlide>
      ))}
      {emptyItems.map((item) => (
        <SwiperSlide key={item}>
          <EmptySlide>{item}</EmptySlide>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Carousel7;
